export type LoadGroupMqttInput = {
    realmId?: string;
    orgId?: string;
    groupId?: string;
    sourceGroupId?: string;
    parentGroupId?: string;
    sourceDeviceId?: string;
    deviceIds?: string[];
};

const getResolvedDeviceId = (sourceDeviceId?: string, deviceIds?: string[]): string | undefined => {
    if (sourceDeviceId) return sourceDeviceId;
    if (Array.isArray(deviceIds) && deviceIds.length) return deviceIds[0];
    return undefined;
};

export const buildLoadGroupMqttTopics = (input: LoadGroupMqttInput): string[] => {
    const { realmId, orgId, groupId, sourceGroupId, parentGroupId, sourceDeviceId, deviceIds } = input;
    const resolvedGroupId = sourceGroupId ?? groupId;
    const baseTopic = `BSSRM/COMMAND_TOPIC/${realmId}/${orgId}`;
    const topics: string[] = [];

    if (!realmId || !orgId) return [];
    if (resolvedGroupId && resolvedGroupId !== orgId && (!parentGroupId || resolvedGroupId !== parentGroupId)) {
        topics.push(`${baseTopic}/${resolvedGroupId}`);
    }

    const resolvedDeviceId = getResolvedDeviceId(sourceDeviceId, deviceIds);
    if (resolvedDeviceId) {
        if (parentGroupId && parentGroupId !== orgId) {
            topics.push(`${baseTopic}/${parentGroupId}/${resolvedDeviceId}`);
        } else {
            topics.push(`${baseTopic}/${resolvedDeviceId}`);
        }
    }

    return Array.from(new Set(topics));
};

export const buildLoadGroupMqttTopicsForRecords = (
    records: any[],
    context: { realmId?: string; orgId?: string }
): string[] => {
    const { realmId, orgId } = context;
    if (!realmId || !orgId || !Array.isArray(records)) return [];

    const topics: string[] = [];
    records.forEach((record: any) => {
        topics.push(
            ...buildLoadGroupMqttTopics({
                realmId,
                orgId,
                groupId: record?.groupId,
                sourceGroupId: record?.sourceGroupId,
                parentGroupId: record?.parentGroupId ?? record?.group?.parentGroupId,
                sourceDeviceId: record?.sourceDeviceId,
                deviceIds: record?.deviceIds,
            })
        );
    });

    return Array.from(new Set(topics));
};
